import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateUserRoleDetailWrapper = styled.div`
  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }

  .accordion-container {
    padding: 0 16px 0 16px;

    .role-header-text {
      margin-top: 24px;
      color: ${COLORS.cirrus_black10};
      ${responsive.MOBILE`
        margin-top: 16px;
      `}
    }

    .role-header-text-create {
      margin: 24px 0px;
    }
  }

  .role-accordion-header {
    margin-bottom: 30px;
  }

  .MuiAccordionDetails-root {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .container-second {
    margin-top: 24px;
    padding-bottom: 30px;
    border-top: 1px dashed ${COLORS.primary_light_blue};
    ${responsive.MOBILE`
      margin-top: 16px;
      padding-bottom: 16px;
    `}
  }

  .location-access {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .power-bi-container {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .power-bi-access-checkbox-container {
    margin-top: 24px;
    word-break: break-word;
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .power-bi-alert-box {
    margin-top: 16px;
  }

  .coach-alert-box {
    margin-top: 16px;
  }
`;
